import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-lesson-resources',
	templateUrl: './lesson-resources.component.html',
	styleUrls: ['./lesson-resources.component.scss']
})
export class LessonResourcesComponent implements OnInit {
	public api: string = environment.api_url;
	@Input() documents: [];

	ngOnInit(): void {}
}
